/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Name_ExistsInputs */

const en_team_manager_group_name_exists = /** @type {(inputs: Team_Manager_Group_Name_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group name already exists.`)
};

const fr_team_manager_group_name_exists = /** @type {(inputs: Team_Manager_Group_Name_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nom du groupe existe déjà.`)
};

const de_team_manager_group_name_exists = /** @type {(inputs: Team_Manager_Group_Name_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Gruppenname existiert bereits.`)
};

const it_team_manager_group_name_exists = /** @type {(inputs: Team_Manager_Group_Name_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il nome del gruppo esiste già.`)
};

const ru_team_manager_group_name_exists = /** @type {(inputs: Team_Manager_Group_Name_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа с таким названием уже существует.`)
};

const es_team_manager_group_name_exists = /** @type {(inputs: Team_Manager_Group_Name_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nombre del grupo ya existe.`)
};

const zh_cn2_team_manager_group_name_exists = /** @type {(inputs: Team_Manager_Group_Name_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`群组名称已存在。`)
};

const ja_team_manager_group_name_exists = /** @type {(inputs: Team_Manager_Group_Name_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ名は既に存在します。`)
};

const hi_team_manager_group_name_exists = /** @type {(inputs: Team_Manager_Group_Name_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह का नाम पहले से मौजूद है।`)
};

const pt_pt2_team_manager_group_name_exists = /** @type {(inputs: Team_Manager_Group_Name_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nome do grupo já existe.`)
};

/**
* | output |
* | --- |
* | "Group name already exists." |
*
* @param {Team_Manager_Group_Name_ExistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_name_exists = /** @type {((inputs?: Team_Manager_Group_Name_ExistsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Name_ExistsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_group_name_exists(inputs)
	if (locale === "de") return de_team_manager_group_name_exists(inputs)
	if (locale === "it") return it_team_manager_group_name_exists(inputs)
	if (locale === "ru") return ru_team_manager_group_name_exists(inputs)
	if (locale === "es") return es_team_manager_group_name_exists(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_group_name_exists(inputs)
	if (locale === "ja") return ja_team_manager_group_name_exists(inputs)
	if (locale === "hi") return hi_team_manager_group_name_exists(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_group_name_exists(inputs)
	return en_team_manager_group_name_exists(inputs)
});